module.exports = __webpack_public_path__ + "static/media/authenticity-icon.ebc2fdae.svg";